import Iconify from "minimals-template/components/Iconify"
import FacilitiesLogo from "routes/@assets/Icon - Facilities-iQ.svg?react"
import AuthoringLogo from "routes/@assets/Icon - Authoring.logo.svg?react"

const CUSTOM_ICONS = {
    FACILITIES_IQ: FacilitiesLogo,
    AUTHORING: AuthoringLogo,
}

export function ApplicationIcon({ appId, icon, width = 16, height = 16, ...props }) {
    const CustomIcon = CUSTOM_ICONS[appId]
    if (CustomIcon) {
        return <CustomIcon aria-hidden="true" focusable="false" width={width} height={height} {...props} />
    }
    return <Iconify icon={icon} width={`${width}px`} height={`${height}px`} {...props} />
}
